export enum StatusType {
  'SUGGESTED' = 'SUGGESTED',
  'ACCEPTED' = 'ACCEPTED',
  'DECLINED' = 'DECLINED',
}
